import LeftSideBarConst from './../../components/LeftSideBar/const';

const Const = {
    SECURITY_START_FETCH_REQUEST: 'SECURITY_START_FETCH_REQUEST',
    SECURITY_CHECK_2F: 'SECURITY_CHECK_2F',
    SECURITY_UPDATE_2F: 'SECURITY_UPDATE_2F',
    [LeftSideBarConst.LEFT_SIDE_BAR_IS_FOLDED_OPEN]: LeftSideBarConst.LEFT_SIDE_BAR_IS_FOLDED_OPEN
};

export default Const;